<template>
    <div>
        <transition name="fade" mode="out-in">
            <div key="1" v-if="!complete">
                <h1>
                    Welcome!
                </h1>
                <p>
                    The ACG Credit Card Required Annual Educational Video is <strong class="text-danger">Past Due</strong>. Access to the Credit Card Resource Center has been restricted until you have completed watching the required video.
                </p>
            </div>
            <div key="2" v-else>
                <p>
                    You have finished your annual required Fair and Responsible Banking education course. This video can be found on the Education page if you would like to rewatch the content at any time. Download your compliance certificate below and retain for your records, then click Continue to the Site.
                </p>
            </div>
        </transition>

        <slot></slot>

        <div v-if="!complete" class="mt-5 mb-3">
            <p class="mb-0">Videos should be viewed using the latest release of Google Chrome.</p>
        </div>
        <template v-if="complete && !pending">
            <p v-if="errorMessage && errorStatusCode !== 422" class="small mt-3 text-danger">{{ errorMessage }}</p>
            <div v-else class="d-flex align-items-center">
                <a href="/landing/annual-training/download">Download Certificate</a>
                <a href="/" class="btn-primary ml-3">Continue to the site</a>
            </div>
        </template>
    </div>
</template>

<script>
import eventBus from '@/event-bus';
import FormButton from '@/components/form/FormButton';
import FormInput from '@/components/form/FormInput';
import AnnualTrainingService from '@/services/annual-training.service';
import FormMixin from '@/mixins/FormMixin';

export default {
    components: {
        FormInput,
        FormButton
    },
    props: {
        requiredVideos: {
            type: Array,
            required: true
        },
        action: {
            type: String
        },
        csrf: {
            type: String
        }
    },
    mixins: [
        FormMixin
    ],
    data() {
        return {
            videos: this.requiredVideos,
            pending: false,
            complete: false
        }
    },
    mounted() {
        eventBus.$on('videoEnded', this.videoEnded);
    },
    methods: {
        async videoEnded(event) {
            this.videos = this.videos.filter(videoId => videoId !== event.videoId);

            if (!this.videos.length) {
                this.complete = true;

                this.pending = true;
                this.errorMessage = '';
                this.errorStatusCode = null;

                try {
                    await AnnualTrainingService.store();

                    this.success = true;
                } catch (error) {
                    this.handleError(error);
                } finally {
                    this.pending = false;
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>
